
import Vue from "vue";
import { ChatMessage } from "../../utils/chat-message";
import AppChatMessage from "./ChatMessage.vue";

export default Vue.extend({
	data(){
		return {
			newestCreatedAt: new Date(),
			shouldAutoScrollDown: true,
			lengthChanged: false,
			lastItemBeforeFetchMore: null as null | Vue
		};
	},
	props: {
		value: {
			type: Array as ()=>ChatMessage[],
			required: true
		}
	},
	watch: {
		"value.length": {
			handler(){
				this.lengthChanged = true;
			},
		}
	},
	methods: {
		scrollToBottom():void{
			if (!this.$refs.scroller) return;
			let scroller = this.$refs.scroller as Vue;
			scroller.$el.scrollTo(0, scroller.$el.scrollHeight);
			this.shouldAutoScrollDown = true;
		},
		onScroll(event:Event){
			if (!this.$refs.scroller) return;
			let scroller = (this.$refs.scroller as Vue).$el;
			let maxScroll = scroller.scrollHeight - scroller.clientHeight - 10;
			this.shouldAutoScrollDown = scroller.scrollTop >= maxScroll;
			if (scroller.scrollTop < 100){
				if (this.value.length > 0 && !this.lastItemBeforeFetchMore){
					// Find the highest item in the list
					for (let item of this.$refs.messages as Vue[]) {
						if (item.$vnode.key == this.value[0].id){
							this.lastItemBeforeFetchMore = item;
							break;
						}
					}
				}
				this.$emit("fetch-more");
			}
		},
	},
	mounted(){
		this.scrollToBottom();
	},
	updated(){
		if (this.shouldAutoScrollDown){
			this.scrollToBottom();
		}else if (this.lengthChanged){
			// Scroll to the highest item on the screen when new data arrives
			if (this.lastItemBeforeFetchMore){
				let scroller = this.$refs.scroller as Vue;
				let scrollHeight = (this.lastItemBeforeFetchMore.$el as HTMLElement).offsetTop;
				scroller.$el.scrollTo(0, scrollHeight);
				this.lastItemBeforeFetchMore = null;
			}
		}
		this.lengthChanged = false;
	},
	components: {
		AppChatMessage
	}
});
